export default __webpack_public_path__ + "static/media/icon.9d2504ed.svg";